import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_dialog_loading = _resolveComponent("ontos-dialog-loading")!
  const _component_ontos_dialog_actions = _resolveComponent("ontos-dialog-actions")!
  const _component_ontos_instance_view = _resolveComponent("ontos-instance-view")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_ontos_instance_edit = _resolveComponent("ontos-instance-edit")!
  const _component_ontos_instance_create = _resolveComponent("ontos-instance-create")!
  const _component_ontos_busy_overlay = _resolveComponent("ontos-busy-overlay")!
  const _component_ontos_view_instance_dialog = _resolveComponent("ontos-view-instance-dialog")!
  const _component_ontos_dialog = _resolveComponent("ontos-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ontos_dialog, {
      "model-value": true,
      fullscreen: _ctx.$vuetify.display.smAndDown,
      "max-width": "1100px",
      target: _ctx.openedFrom || undefined,
      "onUpdate:modelValue": _ctx.onDialogInput
    }, {
      default: _withCtx(() => [
        (_ctx.current.instance && !_ctx.deferView)
          ? _withDirectives((_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                (!_ctx.contentLoaded)
                  ? (_openBlock(), _createBlock(_component_ontos_dialog_loading, { key: 0 }))
                  : _createCommentVNode("", true),
                _withDirectives((_openBlock(), _createBlock(_component_ontos_instance_view, {
                  ref: "view",
                  key: _ctx.contentKey,
                  context: _ctx.current,
                  workspace: _ctx.workspace,
                  preview: _ctx.lead,
                  onLoaded: _ctx.onViewLoaded,
                  onEdit: _ctx.onEdit,
                  onOpenInstance: _ctx.onOpenInstance,
                  onChanged: _ctx.onChildChanged,
                  onDeleted: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDeleted())),
                  onNotFound: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closed'))),
                  onShowMessage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('showMessage', $event))),
                  onShowErrorMessage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onContentError($event)))
                }, {
                  controls: _withCtx(() => [
                    _createVNode(_component_ontos_dialog_actions, {
                      "on-full-page": _ctx.expandView,
                      onClosed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closed')))
                    }, null, 8, ["on-full-page"])
                  ]),
                  _: 1
                }, 8, ["context", "workspace", "preview", "onLoaded", "onEdit", "onOpenInstance", "onChanged"])), [
                  [_vShow, _ctx.contentLoaded]
                ])
              ]),
              _: 1
            }, 512)), [
              [_vShow, _ctx.mode === 'view']
            ])
          : _createCommentVNode("", true),
        (_ctx.mode === 'edit' && _ctx.editing)
          ? (_openBlock(), _createBlock(_component_ontos_instance_edit, _mergeProps({ key: 1 }, _ctx.editing, {
              onSaved: _ctx.onSaved,
              onShowMessage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('showMessage', $event))),
              onShowErrorMessage: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
            }), {
              controls: _withCtx(({dirty, draft, original}) => [
                _createVNode(_component_ontos_dialog_actions, {
                  back: "",
                  dirty: dirty,
                  "on-full-page": () => _ctx.expandEdit(draft, original),
                  onClosed: _ctx.onEditLeft
                }, null, 8, ["dirty", "on-full-page", "onClosed"])
              ]),
              _: 1
            }, 16, ["onSaved"]))
          : _createCommentVNode("", true),
        (_ctx.mode === 'create')
          ? (_openBlock(), _createBlock(_component_ontos_instance_create, _mergeProps({
              key: 2,
              context: _ctx.context
            }, _ctx.creating || {}, {
              onSaved: _ctx.onCreated,
              onShowMessage: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('showMessage', $event))),
              onShowErrorMessage: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
            }), {
              controls: _withCtx(({dirty, draft}) => [
                _createVNode(_component_ontos_dialog_actions, {
                  dirty: dirty,
                  "on-full-page": () => _ctx.expandCreate(draft),
                  onClosed: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('closed')))
                }, null, 8, ["dirty", "on-full-page"])
              ]),
              _: 1
            }, 16, ["context", "onSaved"]))
          : _createCommentVNode("", true),
        _createVNode(_component_ontos_busy_overlay, { model: _ctx.finishing }, null, 8, ["model"]),
        (_ctx.child)
          ? (_openBlock(), _createBlock(_component_ontos_view_instance_dialog, {
              key: 3,
              context: _ctx.child,
              preview: _ctx.childPreview,
              workspace: _ctx.workspace,
              onChanged: _ctx.onChildChanged,
              onDeleted: _ctx.onChildDeleted,
              onClosed: _cache[10] || (_cache[10] = ($event: any) => (_ctx.child = null)),
              onShowMessage: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('showMessage', $event))),
              onShowErrorMessage: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
            }, null, 8, ["context", "preview", "workspace", "onChanged", "onDeleted"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["fullscreen", "target", "onUpdate:modelValue"])
  ]))
}